module.exports = __webpack_public_path__ + "static/media/logoMed.3e3e8ee0.png";